import { SimpleImageAttachmentAdapter } from '@assistant-ui/react';

import { downscaleImage } from './image-preprocessing';

// Apply image preprocessing on the adapter's actual add path. Keeping this in
// its own module prevents UI composition from silently bypassing the upload
// policy again.
export class DownscalingImageAttachmentAdapter extends SimpleImageAttachmentAdapter {
  override async add(state: { file: File }) {
    return super.add({ file: await downscaleImage(state.file) });
  }
}
